import ApiService from "./api.service.js";

export default function Internationalize() {}

Internationalize.countries = () => {
  return ApiService.get("/countries");
};

Internationalize.regions = (code: string) => {
  return ApiService.get(`/countries/${code}/regions`);
};
